import { useMemo } from "react";

import MaterialReactTable, { type MRT_ColumnDef } from "material-react-table";

import Box from "@mui/material/Box/Box";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";

export type Logs = {
  user: string;
  appVersion: string;
  systemVersion: string;
  phoneModel: string;
  error: any;
  alert: string;
  server: string;
  createdAt: Date;
};

export type TableProps = {
  data: Logs[] | null;
};

const Table = ({ data, isLoading }: any) => {
  const columns = useMemo<MRT_ColumnDef<Logs>[]>(
    () => [
      {
        id: "logs",
        header: "Logs",
        columns: [
          {
            id: "user",
            header: "Usuário",
            size: 150,
            accessorKey: "user",
          },
          {
            accessorKey: "appVersion",
            header: "Versão do App",
            size: 100,
          },
          {
            accessorKey: "server",
            enableClickToCopy: true,
            header: "Servidor",
            size: 250,
          },
          {
            accessorKey: "alert",
            header: "Nível de Alerta",
            size: 100,
            Cell: ({ cell }) => (
              <Box
                component="span"
                sx={(theme) => ({
                  backgroundColor:
                    cell.getValue() === "Crítico"
                      ? theme.palette.error.main
                      : cell.getValue() === "Moderado"
                      ? theme.palette.warning.main
                      : theme.palette.success.main,
                  borderRadius: "0.25rem",
                  color: "#fff",
                  maxWidth: "9ch",
                  p: "0.25rem",
                })}
              >
                {cell.getValue()?.toLocaleString()}
              </Box>
            ),
          },
          {
            accessorKey: "systemVersion",
            header: "Versão do Sistema",
            size: 150,
          },
          {
            accessorKey: "phoneModel",
            header: "Versão do Celular",
            size: 200,
          },
          {
            accessorKey: "error",
            header: "Detalhar",
            size: 100,
          },
          {
            accessorFn: (row) => new Date(row.createdAt),
            id: "createdAt",
            header: "Data de Criação",
            filterFn: "lessThanOrEqualTo",
            sortingFn: "datetime",
            Cell: ({ cell }) => {
              const arr = cell.getValue()?.toString()?.split(" ") ?? [
                "",
                "",
                "",
                "",
                "",
              ];
              return `${arr[0]} ${arr[1]} ${arr[2]} ${arr[3]} ${arr[4]}`;
            },
            Header: ({ column }) => <em>{column.columnDef.header}</em>,
            Filter: ({ column }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  onChange={(newValue) => {
                    column.setFilterValue(newValue);
                  }}
                  slotProps={{
                    textField: {
                      helperText: "Filter Mode: Less Than",
                      sx: { minWidth: "120px" },
                      variant: "standard",
                    },
                  }}
                  value={column.getFilterValue()}
                />
              </LocalizationProvider>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <>
      <MaterialReactTable
        columns={columns}
        state={{ isLoading, density: "compact" }}
        data={data}
        enableColumnFilterModes
        enablePinning
        localization={MRT_Localization_PT_BR}
        enableRowSelection
        initialState={{ showColumnFilters: true }}
        positionToolbarAlertBanner="bottom"
      />
    </>
  );
};

export default Table;
